import React, { useContext } from "react";
import { Input } from "antd";
import Form from "antd/lib/form/Form";
import { ImplementerProfileFormContext } from "../../ImplementerProfileFormContext";

export const ContactEmailInput = (props: any) => {
  const implementerAccountContext = useContext(ImplementerProfileFormContext);
  const {
    form,
    isBusy,
    onFieldsChange,
    implementerProfile
  } = implementerAccountContext;
  const { getFieldDecorator } = form;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFieldsChange({
      key: event.target.name,
      value: event.target.value
    });
  };

  return (
    <Form.Item label="Correo electrónico">
      {getFieldDecorator("contactEmail", {
        rules: [
          {
            required: true,
            message: "Por favor, ingresa el correo del contacto.",
          },
          {
            type: "email",
            message: "Ingresa un correo válido."
          }
        ],
        initialValue: implementerProfile?.contactEmail
      })(
        <Input
          disabled={isBusy}
          id="contactEmail"
          name="contactEmail"
          placeholder="Correo electrónico"
          onChange={onChange}
          size="large" />
      )}
    </Form.Item>
  );
};
